import type { QueryKey } from '@tanstack/react-query';
import * as api from '../../redux/api';
import type { FossaSubscriptionPlan } from '../../types';
import { useQuery } from '../../ReactQuery';

function getCurrentPlan() {
  return api.get<FossaSubscriptionPlan>(`/api/organization/subscription`);
}

export const CURRENT_PLAN_QUERY_KEY: QueryKey = ['current-plan'];

/**
 * Hook to fetch the current plan the organization is in.
 */
export function useGetCurrentPlan() {
  return useQuery({
    queryKey: CURRENT_PLAN_QUERY_KEY,
    queryFn: getCurrentPlan,
  });
}
